module.exports = __webpack_public_path__ + "images/assets/1e95e81956029aeef9d336d0dc1cb8bd.svg";